import React from 'react';
import { Toggle as CarbonToggle, ToggleProps } from '@carbon/react';

export const Toggle = ({ children, ...props }: ToggleProps) => (
  <CarbonToggle {...props}>{children}</CarbonToggle>
);

Toggle.displayName = 'Toggle';
